@if (!field.hidden) {
  <div animate.enter="fade-in" class="flex flex-col w-full mb-3">
    <div class="mb-2">
      <div class="leading-6 font-medium">{{ field.label | localize }}@if (field.required) {
        <span> *</span>
      }</div>
      @if (field.hint) {
        <div class="text-md text-secondary">{{ field.hint | localize }}</div>
      }
    </div>
    @if (!field.readonly && !field.control.disabled) {
      <div class="flex justify-end mb-4">
        @if (editing) {
          <button mat-raised-button class="mx-2" color="primary" (click)="undo()">
            <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:undo'"></mat-icon>
            <span class="ml-2">{{ 'undo' | transloco }}</span>
          </button>
        }
        @if (editing) {
          <button mat-raised-button class="mx-2" color="primary" (click)="clear()">
            <mat-icon class="text-on-primary" [svgIcon]="'mat_outline:clear'"></mat-icon>
            <span class="ml-2">{{ 'clear' | transloco }}</span>
          </button>
        }
        <button mat-raised-button color="primary" class="mx-2" (click)="toggleEditing()">
          <mat-icon class="text-on-primary" [svgIcon]="editing ? 'mat_outline:save' : 'mat_outline:edit'"></mat-icon>
          <span class="ml-2">{{ (editing ? 'save' : 'edit') | transloco }}</span>
        </button>
        <button mat-raised-button color="warn" class="mx-2" (click)="editing = false">
          <span class="ml-2">{{ 'cancel' | transloco }}</span>
        </button>
      </div>
    }
    <canvas class="border-2 border-dashed border-gray-400" [class.hidden]="!editing || field.readonly || field.control.disabled"
    #canvas width="320px" height="250px" style="touch-action: none;"></canvas>
    @if (image && !editing) {
      <img class="w-5/6" [src]="image">
    }
    @if (!field.readonly && !field.control.disabled && field.control.touched && field.control.errors) {
      @if (field.control.errors.required) {
        <div class="text-sm text-warn leading-none font-medium mt-2">
          {{ 'errorRequiredField' | transloco }}
        </div>
      }
    }
  </div>
}